module.exports = __webpack_public_path__ + "static/media/30.a95cd16a.jpg";